import React from 'react'
import { useHistory } from 'react-router-dom'

//import usMsaAll from '../Map/cb_2018_us_cbsa_20m_wkid102004.json2'

import styles from './SearchPopover.module.scss'

const SearchPopoverMsaItems = React.forwardRef(
  (
    {
      criteria,
      onAdd,
      searchText,
      visible: isVisible,
      entity,
      activeMetros,
      setSearchText,
      setSearchValue,
      setPopoverVisible,
      setSearchLocationValue,
      setSearchLocationTextMethod,
    },
    ref
  ) => {
    const history = useHistory()
    let metros = activeMetros.response_data ? activeMetros.response_data : activeMetros
    const filteredMetros = metros.filter((metro) => {
      if (
        (metro.label &&
          metro.label.toLowerCase().includes(searchText.toLowerCase())) 
        // metro.value.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return metro
      } else {
        return null
      }
    })
    const slicedFilteredMetros = filteredMetros.slice(0, 10)
    return (
      <>
        {slicedFilteredMetros.map((option) => (
          
          <li
            data-option
            key={option.value+'-'+option.geo_parent}
            onClick={() => {
              if (entity === 'VulnerabilityEvent') {
                setSearchLocationValue(option.value)
                setSearchText(option.value)
                setSearchValue(option.label)
                setSearchLocationTextMethod(option.label)
                setPopoverVisible(false)
              } else {
                entity.toLowerCase() === 'flu' ?
                window.location.href = `/${entity}MSADashboard/${option.geo_parent}/MSA/${option.value}`
                :
                window.location.href = `/forecasts/${entity}MSADashboard/${option.geo_parent}/MSA/${option.value}`
              }
            }}
            onKeyDown={(event) => {
              const { key, currentTarget } = event
              const next = key === 'ArrowDown'
              const prev = key === 'ArrowUp'

              if (!next && !prev) return

              event.preventDefault()

              const nextFocus =
                currentTarget[
                  next ? 'nextElementSibling' : 'previousElementSibling'
                ]

              if (nextFocus) nextFocus.focus()
            }}
            onKeyPress={({ key }) =>
              key === 'Enter' &&
              ( entity.toLowerCase() === 'flu' ?
                window.location.href = `/${entity}MSADashboard/${option.geo_parent}/MSA/${option.value}`
                :
                window.location.href = `/forecasts/${entity}MSADashboard/${option.geo_parent}/MSA/${option.value}`)
            }
            tabIndex={-1}
          >
            <span>
              {option.label} ({option.geo_parent}){' '}
              <span style={{ color: '#7D7F81', paddingLeft: '5px' }}> MSA</span>
            </span>
          </li>
        ))}
      </>
    )
  }
)
export default SearchPopoverMsaItems
